import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import wolfpackLogo from "../../../commom/Assets/images/LogoNew.png";
import spinWheelImg from '../../../style/images/spin-wheel.png';

interface SpinPopupProps {
    open: boolean;
    onClose: () => void;
    onSpinNow: () => void;
    spinCount?: number;
}

const SpinPopup: React.FC<SpinPopupProps> = ({ open, onClose, onSpinNow, spinCount = 1 }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    background: 'linear-gradient(180deg, #23242C 0%, #17181D 100%)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    borderRadius: '30px',
                    width: '400px',
                    maxWidth: '90vw',
                    padding: '28px 24px',
                    position: 'relative',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                },
            }}
        >
            <IconButton onClick={onClose} sx={{ position: 'absolute', top: '16px', right: '16px', color: '#B0B3B8' }}>
                <CloseIcon />
            </IconButton>

            <Box display="flex" justifyContent="center" alignItems="center" gap="8px" mb={6}>
                <img src={wolfpackLogo} alt="Wolfpack" style={{ height: '28px', width: 'auto' }} />
            </Box>

            <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '26px', textAlign: 'center', lineHeight: 1.2, mb: 1 }}>
                Your Spin Is Now Available
            </Typography>

            <Typography sx={{ color: '#9A9CA5', fontSize: '18px', textAlign: 'center', mb: 3 }}>
                Spin now to see what you won.
            </Typography>

            <Box display="flex" justifyContent="center" mb={2}>
                <img src={spinWheelImg} alt="Spin wheel" style={{ width: '250px', height: 'auto' }} />
            </Box>

            <Box
                onClick={onSpinNow}
                sx={{
                    background: 'linear-gradient(90deg, #F2674A 0%, #FFA347 100%)',
                    borderRadius: '50px', py: '14px', textAlign: 'center', cursor: 'pointer',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px', mb: 2,
                    transition: 'filter 0.2s', '&:hover': { filter: 'brightness(0.95)' },
                }}
            >
                <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '16px' }}>Spin Now</Typography>
                <span style={{ color: 'white', fontSize: '18px' }}>›</span>
            </Box>

            <Typography
                onClick={onClose}
                sx={{ color: '#9A9CA5', fontSize: '14px', textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', '&:hover': { color: 'white' } }}
            >
                Maybe Later
            </Typography>
        </Dialog>
    );
};

export default SpinPopup;